// removed by extract-text-webpack-plugin
module.exports = {"root":"_3ciIn","title":"_11vOp","content":"_3xDhL","price":"_1PgGM","priceInfo":"_2VYx_","features":"_37Q5Y","modalButton":"K6sAN"};


//////////////////
// WEBPACK FOOTER
// ./components/DialogPlan/ModalCard/styles.scss
// module id = 760
// module chunks = 0